import React from 'react'
import './mancollection.css'
const Mancollection = () => {
  return (
    <>
 
    </>
  )
}

export default Mancollection
